export default {"src":"/_next/static/media/telegram.a16cdf90.svg","height":92,"width":92,"blurWidth":0,"blurHeight":0};